<template>
  <div>{{ type }}</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {object: {type: Object, required: true}},
    data(){
        return {

        }
    },
    computed: {
        ...mapGetters({
            categories: 'sanitaire/categorieAnalyses',
            typeAnalyses: 'sanitaire/typeAnalyses'
        }),
        type(){
            let c = this.categories.find(item => item.uid === this.object.categorieAnalyse)
            if(c){
                let t = this.typeAnalyses.find(item => item.uid === c.typeAnalyse)
                if(t) return t.libelle
                return '-'
            }
            return '-'
        }
    }
}
</script>

<style>

</style>